import axios from 'axios';
import serviceConfig from "./serviceConfig";
import { getToken } from "./../auth/utils";
import { checkStatusCode } from "./services";
import { removeStorage } from "../../@utility/app/storage";
import queryString from "query-string";

// const queryString = require('query-string');
const svConfig = { ...serviceConfig };

// axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const loadDepositFirst = async () => {
    // axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    let config = {
        method: svConfig.method_get,
        url: '/customer/payment-v2/deposit/channel',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: {}
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const confirmDepositPromotion = async (dataJson) => {
    // axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    let config = {
        method: svConfig.method_post,
        url: '/customer/payment-v3/deposit/promotion',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(dataJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const confirmDeposit = async (data, path = "/customer/payment/deposit/channel-v3") => {
    const {
        amount,
        bankId,
        typePage,
        channel,
        channelId,
        // channelMode
    } = data;

    let methodType = 4;
    let selectType = 1;

    if (typePage === "promtpay" || typePage === "qrcode") {
        methodType = 5;
        selectType = 3;
    }
    else if (typePage === "truemoney") {
        methodType = 6;
        selectType = 2;
    }
    else if (typePage === "bank") {
        methodType = 4;
    }
    else {
        methodType = 0;
    }

    const dataJson = {
        "amount": amount,
        "bankId": bankId,
        "method": methodType,
        channel,
        channelId,
        "select": selectType
    };

    removeStorage("paySrc");
    removeStorage("payMode");
    removeStorage("payAccount");
    removeStorage("payAmount");
    removeStorage("payTimeOut");
    removeStorage("processDeposit");
    removeStorage("depositPromptPayTime");
    removeStorage("channelPaySelect");
    removeStorage("payRate");

    let config = {
        method: svConfig.method_post,
        url: path,
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(dataJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result, message } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result,
            message,
            code
        };
    }
}

const confirmDepositCrypto = async (data, path = "/customer/payment-v3/deposit/submit-crypto") => {
    removeStorage("paySrc");
    removeStorage("payMode");
    removeStorage("payAccount");
    removeStorage("payAmount");
    removeStorage("payTimeOut");
    removeStorage("processDeposit");
    removeStorage("depositPromptPayTime");
    removeStorage("channelPaySelect");

    let config = {
        method: svConfig.method_post,
        url: path,
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(data)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result, message } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result,
            message,
            code
        };
    }
}

const confirmStep = async (data) => {
    // axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    const {
        td_id,
        promotion_status,
        promotion_condition_id
    } = data;

    let myJson = {
        "td_id": td_id,
        "promotion_status": promotion_status,
        "promotion_condition_id": promotion_condition_id
    };

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/deposit/confirm',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const confirmPaySlip = async (data) => {
    // if (process.env.REACT_APP_PAYMENT_V2 === "true" || process.env.REACT_APP_PAYMENT_V2 === true) {
    //     axios.defaults.baseURL = process.env.REACT_APP_API_URL_V2;
    // }
    // else {
    //     // axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    // }

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/deposit/slip',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: data
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const confirmPaySlipChannel = async (data) => {
    // if (process.env.REACT_APP_PAYMENT_V2 === "true" || process.env.REACT_APP_PAYMENT_V2 === true) {
    //     axios.defaults.baseURL = process.env.REACT_APP_API_URL_V2;
    // }
    // else {
    //     // axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    // }

    let config = {
        method: svConfig.method_post,
        url: "/customer/payment-v2/deposit/slip",
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: data
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}


const confirmUploadCheckSlip = async (data) => {
    // if (process.env.REACT_APP_PAYMENT_V2 === "true" || process.env.REACT_APP_PAYMENT_V2 === true) {
    //     axios.defaults.baseURL = process.env.REACT_APP_API_URL_V2;
    // }
    // else {
    //     // axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    // }

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/deposit/verify-slip',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: data
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result, message } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code,
            message: message
        };
    }
}

const checkDeposit = async (depositId) => {
    // axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    let myJson = {
        "id": depositId
    };

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/deposit/check',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const cancenDeposit = async () => {
    // if (process.env.REACT_APP_PAYMENT_V2 === "true" || process.env.REACT_APP_PAYMENT_V2 === true) {
    //     axios.defaults.baseURL = process.env.REACT_APP_API_URL_V2;
    // }
    // else {
    //     // axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    // }

    let config = {
        method: svConfig.method_post,
        url: "/customer/payment-v2/deposit/cancel",
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: {}
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const getBankAgent = async (bankId) => {
    // axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    let myJson = {
        "bankId": bankId
    };

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/deposit/bank/agent',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const getBankCustomer = async (bankId) => {
    // axios.defaults.baseURL = process.env.REACT_APP_API_URL;

    let myJson = {
        "bankId": bankId
    };

    let config = {
        method: svConfig.method_post,
        url: '/customer/payment/deposit/bank/customer',
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(myJson)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result: result,
            code: code
        };
    }
}

const confirmDepositP2P = async (data, path = "/customer/payment-v3/deposit/submit-p2p") => {
    removeStorage("paySrc");
    removeStorage("payMode");
    removeStorage("payAccount");
    removeStorage("payAmount");
    removeStorage("payTimeOut");
    removeStorage("processDeposit");
    removeStorage("depositPromptPayTime");
    removeStorage("channelPaySelect");
    removeStorage("paymentResult");

    let config = {
        method: svConfig.method_post,
        url: path,
        headers: {
            "Authorization": `${svConfig.headerType} ${getToken()}`,
            "Content-Type": svConfig.contentType
        },
        data: queryString.stringify(data)
    };

    const dataPromise = await axios(config).then((response) => response.data).catch((e) => e.response.data);
    const { code, result, message } = dataPromise;

    if (checkStatusCode(code)) {
        return {
            result,
            message,
            code
        };
    }
}

export {
    loadDepositFirst,
    confirmDeposit,
    confirmStep,
    confirmPaySlip,
    checkDeposit,
    cancenDeposit,
    getBankAgent,
    getBankCustomer,
    confirmUploadCheckSlip,
    confirmPaySlipChannel,
    confirmDepositPromotion,
    confirmDepositCrypto,
    confirmDepositP2P
};